import {
	PRODUCT_DETAIL_SUCCESS,
	PRODUCT_DETAIL_REQUEST,
	PRODUCT_DETAIL_ERROR,
	PRODUCT_DETAIL_CLEAR
} from 'actions/productDetailsActions';
import { asmActions } from 'actions/saleActions';
import { INIT, LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';

const defaultState = {
	asyncStatus: INIT
};

export default function productDetailReducer(state = defaultState, action = {}) {
	switch (action.type) {
		case PRODUCT_DETAIL_REQUEST:
			return Object.assign({}, state, {
				asyncStatus: LOADING
			});
		case PRODUCT_DETAIL_SUCCESS:
			return Object.assign(
				{},
				state,
				{
					asyncStatus: SUCCESS,
					timeStamp: new Date().getTime()
				},
				action.data
			);
		case PRODUCT_DETAIL_ERROR:
			return Object.assign(
				{},
				state,
				{
					asyncStatus: ERROR
				},
				action.error
			);
		case PRODUCT_DETAIL_CLEAR:
			return defaultState;
		case asmActions.ASM_PRODUCT_OOS:
			const data = Object.assign({}, state.data, {
				product_asm_default: {
					data: [action.data]
				}
			});
			return Object.assign({}, state, {
				data
			});
		default:
			return state;
	}
}
